import { type ClassNameMap, Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { COLORS } from 'theme/MainTheme';
import { trackEvent, GACommonEventAction, GAEventCategory} from 'services/googleAnalytics';
import clsx from 'clsx';
import { type ReactNode } from 'react';
import {Files} from 'components/icons';

const ITEMS_PER_ROW = 4;

const getBgClassName = (classes: ClassNameMap, index: number) => {
  const rows = Math.floor(index / ITEMS_PER_ROW);
  const colorIndex = (index + rows) % ITEMS_PER_ROW;

  switch (colorIndex) {
    case 0:
      return classes.violet;
    case 1:
      return classes.red;
    case 2:
      return classes.yellow;
    case 3:
      return classes.green;
  }
};

const useStyles = makeStyles(() => ({
  fileItem: {
    alignItems: 'center',
    borderRadius: 16,
    boxShadow: '0px 3px 5px 1px rgb(0 0 0 / 25%)',
    cursor: 'pointer',
    display: 'flex',
    height: 180,
    justifyContent: 'center',
    margin: '20px auto',
    textAlign: 'center',
    transform: 'scale(1)',
    transition: 'all .2s ease-in-out',
    width: '75%',

    '&:hover': {
      transform: 'scale(1.1)',
    },
  },
  green: {
    backgroundColor: COLORS.GREEN,
  },
  red: {
    backgroundColor: COLORS.RED,
  },
  title: {
    color: COLORS.WHITE,
    fontSize: 18,
    fontWeight: 'bold',
    lineHeight: '22px',
    padding: '15px 15px 0',
    textAlign: 'center',
  },
  violet: {
    backgroundColor: COLORS.VIOLET,
  },
  yellow: {
    backgroundColor: COLORS.YELLOW,
  },
  icon: {
    height: 70
  }
}), { name: 'FileItem' });

export type File = {
  fileName: string;
  filePath: string;
  label: ReactNode;
};

export type FileItemProps = {
  file: File;
  index: number;
};

const FileItem = ({ file, index }: FileItemProps): JSX.Element => {
  const classes = useStyles();
  const bgClassName = getBgClassName(classes, index);
  

  const onFileClick = () => {
    trackEvent(GAEventCategory.HELP, GACommonEventAction.CLICK, file.fileName);
    window.open(`${file.filePath}/${file.fileName}`);
  };

  return (
    <Grid item md={3} xs={6}>
      <Grid
        onClick={onFileClick}
        alignContent="center"
        className={clsx([classes.fileItem, bgClassName])}
        container
      >
        <Grid item xs={12}>
          <Files className={classes.icon} fontSize='xlarge' />
        </Grid>

        <Grid className={classes.title} item xs={12}>
          {file.label}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default FileItem;